module.exports = __webpack_public_path__ + "img/bg-login.f268b934.png";